module.exports = __webpack_public_path__ + "static/img/link-2.dc0f4ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link-2.png
// module id = J5YU
// module chunks = 73